import { render, staticRenderFns } from "./CustomMessageInput.vue?vue&type=template&id=201321b2&scoped=true&"
import script from "./CustomMessageInput.vue?vue&type=script&lang=js&"
export * from "./CustomMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomMessageInput.vue?vue&type=style&index=0&id=201321b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201321b2",
  null
  
)

export default component.exports